import IconButton from '@mui/material/IconButton'
import React from 'react'
import Tooltip from '@mui/material/Tooltip'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'

interface ButtonProps {
  onClick: () => void
  title?: string
  children?: React.ReactNode
  dataTestId?: string
}

export const RemoveButton: React.FC<ButtonProps> = ({ onClick, title = 'Remove item', children, dataTestId }) => (
  <Tooltip title={title}>
    <IconButton
      data-testid={dataTestId}
      onClick={onClick}
    >
      {children || <DeleteOutlineIcon className='icon-pantoneBlue' />}
    </IconButton>
  </Tooltip>
)
